import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import SouthIcon from '@mui/icons-material/South';
import './UserSwitchModal.scss';

const UserSwitchModal = ({ open, onClose, onConfirm, selectedUser }) => {
  return (
    <Dialog open={open} onClose={onClose}
      PaperProps={{
        className: 'user-switch-modal',
      }}>
      <Box className='dialog-title'>Are you sure you want to switch?</Box>
      <Box className='error-text'>
        <ErrorIcon className='error-icon'/>
          Switching usernames will interrupt anything not saved.
      </Box>
      <DialogContent className='dialog-content'>
        <Box className='dialog-text'>Please confirm you want to switch profiles from</Box>
        <Box className='user-name-text'>{selectedUser.current}</Box>
        <SouthIcon className='south-arrow'></SouthIcon>
        <Box className='user-name-text'>{selectedUser.new}</Box>
        <Box className='dialog-text note'>Everything on the page will update based on this username.</Box>
      </DialogContent>
      <DialogActions className='dialog-button-container'>
        <Button disableRipple className='dialog-cancel' onClick={onClose}>
          <span>Cancel</span>
        </Button>
        <Button disableRipple className='dialog-confirm' onClick={() => onConfirm(selectedUser.new)}>
        <span>Confirm</span>                        
        </Button>
      </DialogActions>
    </Dialog>
  );
};

  export default UserSwitchModal;
